import React, { useState, useEffect } from 'react';
import ModalDropdown from '../../component/ModalDropdown';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../modalComponents/ConfirmationModal';
import { logout } from '../../service/helpers';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useSelector, useDispatch } from 'react-redux';
import { getUserProfile } from '../../redux/reducers/diffusionSlice';
import { saveUserData } from '../../redux/reducers/authSlice';
import usePermission from '../../utils/customeHooks/usePermission';
import { permissionKey } from '../../constants/constants';

const ProfileDropdown = (props) => {
  const userData = useSelector((state) => state.auth.userData);
  const dispatch = useDispatch();
  const { isOpen = false, closePopUp, notifymodal = false, profileURL } = props;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const notificationMenuOpen = Boolean(anchorEl);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState('Allow');
  const profileDetails = {
    name: userData?.name,
    email: userData?.email,
    role: userData?.roles ? userData?.roles?.name?.replaceAll('_', ' ') : '',
  };
  const { getModulePermission } = usePermission();
  const hasPermissionToViewSettings = getModulePermission('common', 'settings', permissionKey.view);

  useEffect(() => {
    if (isOpen) {
      fetchUserProfile();
    }
  }, [isOpen]);

  const fetchUserProfile = async () => {
    try {
      const res = await getUserProfile();
      if (res?.data?.user) {
        dispatch(saveUserData(res.data.user));
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };
  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  const logoutConfirmation = () => {
    logout();
  };

  const handleProfileClick = () => {
    navigate('/setting/profile');
    closePopUp();
  };

  const handleSettingsClick = () => {
    navigate('/setting/profile');
    closePopUp();
  };

  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAllowNotifications = () => {
    setNotificationStatus('Allow');
    handleNotificationMenuClose();
  };

  const handleMuteNotifications = () => {
    setNotificationStatus('Mute');
    handleNotificationMenuClose();
  };

  return (
    <>
      <div className='relative' />
      <ModalDropdown isOpen={isOpen} closePopUp={closePopUp} notifymodal={notifymodal}>
        <div className='bg-white w-[300px] rounded-lg shadow'>
          <div className='p-4 flex items-center border-b border-gray-200'>
            <div className='w-14 h-14 rounded-full overflow-hidden mr-4 border flex items-center justify-center text-black text-lg font-semibold'>
              {profileURL ? (
                <img src={profileURL} alt='Profile' className='w-full h-full object-cover' />
              ) : (
                profileDetails.name?.charAt(0)?.toUpperCase() || '?'
              )}
            </div>

            <div>
              <h3 className='text-base font-semibold text-gray-900 m-0'>{profileDetails.name}</h3>
              <p className='text-sm text-blue-800 font-semibold m-0 capitalize'>
                {profileDetails.role}
              </p>
              <p className='text-sm text-gray-500 m-0'>{profileDetails.email}</p>
            </div>
          </div>

          <hr className='border-gray-200' />

          <div>
            <div
              className='flex items-center justify-between px-4 py-3 hover:bg-gray-100 cursor-pointer'
              onClick={handleProfileClick}
            >
              <div className='flex items-center'>
                <PersonOutlineIcon className='text-gray-600 mr-3' />
                <span className='text-gray-700 font-medium text-sm'>My Profiles</span>
              </div>
              <ChevronRightIcon className='text-gray-400' />
            </div>
            {hasPermissionToViewSettings && (
              <div
                className='flex items-center justify-between p-4 hover:bg-gray-50 cursor-pointer'
                onClick={handleSettingsClick}
              >
                <div className='flex items-center'>
                  <SettingsOutlinedIcon className='text-gray-700 mr-4' />
                  <span className='text-gray-800 font-medium'>Settings</span>
                </div>
                <ChevronRightIcon className='text-gray-400' />
              </div>
            )}

            <div
              className='flex items-center justify-between p-4 hover:bg-gray-50 cursor-pointer'
              onClick={handleNotificationClick}
            >
              <div className='flex items-center'>
                {notificationStatus === 'Allow' ? (
                  <NotificationsNoneOutlinedIcon className='text-gray-700 mr-4' />
                ) : (
                  <NotificationsOffOutlinedIcon className='text-gray-700 mr-4' />
                )}
                <span className='text-gray-800 font-medium'>Notification</span>
              </div>
              <span className='text-gray-500'>{notificationStatus}</span>
            </div>

            <Menu
              anchorEl={anchorEl}
              open={notificationMenuOpen}
              onClose={handleNotificationMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              PaperProps={{
                className: 'shadow-md rounded-md mt-2',
              }}
            >
              <MenuItem onClick={handleAllowNotifications}>Allow</MenuItem>
              <MenuItem onClick={handleMuteNotifications}>Mute</MenuItem>
            </Menu>

            <div
              className='flex items-center justify-between p-4 hover:bg-gray-50 cursor-pointer'
              onClick={() => setShowLogoutModal(true)}
            >
              <div className='flex items-center'>
                <LogoutOutlinedIcon className='text-gray-700 mr-4' />
                <span className='text-gray-800 font-medium'>Log Out</span>
              </div>
            </div>
          </div>
        </div>
      </ModalDropdown>
      {showLogoutModal && (
        <ConfirmationModal
          isOpen={showLogoutModal}
          closePopUp={handleLogoutCancel}
          title='Confirm Logout'
          description={
            <>
              Are you sure you want to logout
              <span className='normal-QuestionMark'> ?</span>
            </>
          }
          nobtnText='Cancel'
          yesbtnText='Logout'
          clearHandler={handleLogoutCancel}
          successHandler={logoutConfirmation}
        />
      )}
    </>
  );
};

export default ProfileDropdown;
